import React, {Component} from "react";
import * as UserService from "../../../../services/User/UserService";
import * as CookieService from "../../../../services/Cookie/CookieService";

class UserDropDown extends Component {
    state = {
        isToggle: false,
        list: [
            {id: 0, text:"My Profile", link: "/app/profile", checked: false},
            {id: 1, text:"Point", link: "", checked: false},
            {id: 2, text:"Logout", link: "", checked: false}
        ],
        userProfile: {},
        isUpdate: false
    }

    componentDidMount = () => {
    	this.userProfileInfo();
    }
    
    componentWillReceiveProps = (nextProps) => {
	this.userProfileInfo();
    }

    // dropdown menu click 여부
    onDropDownClicked = () => {
        const { isToggle } = this.state;
        const { list } = this.state;

        // dropdown menu off시, 선택 값 초기화
        if(isToggle) {
            list.map((item) => item.checked = false);
        }

        this.setState({
            isToggle: !isToggle,
            list: list
        });
    }

    // dropdown item click 여부
    onItemSelected = (id) => {
        const { list } = this.state;
        const index = list.findIndex(item => item.id === id);
        const changeList = [...list];
        changeList.map((item) => item.checked = (item.id === index));
        this.setState({
            list: changeList
        });
        if (id === 2) {
            // logout
            CookieService.removeCookie();
        }
    }

    // dropdown menu on 여부에 따라 menuList 보여주기
    userMenuOn = () => {
        const { id, list, link, isToggle } = this.state;
        if(isToggle) {
            const itemList = list.map(
                ({id, link, text, checked}) => (
                    <li key={id} className={(checked)? "menu active" : "menu"} onClick={() => this.onItemSelected(id)}>
                        <a href={link}>{text}</a>
                    </li>
                )
            )

            return (
                <div className="menuWrapper" onMouseLeave={this.onDropDownClicked}>
                    <ul className="menuList">
                        {itemList}
                    </ul>
                </div>
            );
        }
    }

    /* user profile 조회 */
    userProfileInfo = () => {
        UserService.userProfile().then( (response) => {
            if( response.status === 200 ) {
                this.setState({
                    userProfile: response.data.data
                })
            } else {
                alert('USER PROFILE FAILED');
            }
        }).catch( (error) => {
            console.log(error);
            alert('SERVER ERROR');
        });
    }

    render() {
        return (
            <div className="userWrapper">
                <div className="btnWrapper">
                    <div className={(this.state.isToggle)? "btnMenu on" : "btnMenu"} onClick={this.onDropDownClicked}>
                        <span className="profile">
                            {this.state.userProfile.thumbnailImage === null ?
                            <img className="thumbnail" src="/images/common/img_profile.png" alt="profile" />
                            :
                            <img className="thumbnail" src={this.state.userProfile.thumbnailImage} alt="profile" />
                            }
                        </span>
                        <span className="name" onClick={this.onDropDownClicked}>{this.state.userProfile.name}</span>
                    </div>
                </div>
                {this.userMenuOn()}
            </div>
        );
    }
}

export default UserDropDown;



// WEBPACK FOOTER //
// ./src/components/Containers/Header/UserDropDown/index.js